import styled from 'styled-components';
import { media } from '../../../components_desktop/css_global/utils.css';

/*
  PORTRAIT WIDTHS:
  320:  iPhone 5
  360:  Galaxy S5
  375:  iPhone 6
  412:  Nexus 6P
  412:  Nexus 5X
  414:  iPhone 6+
  768:  iPad Mini
  768:  iPad
  1024: iPad Pro
  LANDSCAPE WIDTHS:
  568:  iPhone 5
  640:  Galaxy S5
  667:  iPhone 6
  684:  Nexus 5X (viewport offset by OS nav bar)
  732:  Nexus 6P
  736:  iPhone 6+
  1024: iPad
  1024: iPad Mini
  1366: iPad Pro
*/

const ProductCellColumn = styled.div`
  display: flex;
  flex-direction: column;
  ${({ isDesktop }) => (isDesktop ? 'margin-top: 25px;' : null)}
  ${({ isDesktop }) => (isDesktop ? 'margin-bottom: 25px;' : null)}
  justify-content: space-between;
  ${({ isDesktop }) => (isDesktop ? 'width: 235px' : null)}
  box-sizing: border-box;

  & *,
  & *:before,
  & *:after {
    box-sizing: inherit;
  }
`;

export default ProductCellColumn;
